import React, {
  Children, cloneElement, useEffect, useRef,
} from 'react';

import { useNavigation } from '@refinedev/core';
import { useForm, UseFormReturnType } from '@refinedev/react-hook-form';

import { Button } from '@rrexpress/core';
import { isEmpty } from 'lodash';

export interface IBaseForm {
  children: React.ReactNode,
  onFinish: (data: any) => void
  onCancel?: () => void
  initialValue?: Record<string, any>
  footer?: React.ReactNode;
  customForm?: UseFormReturnType;
}

// export const BaseForm = ({ children, onFinish, form, initialValue }: IBaseForm) => {
export const BaseForm = ({
  children,
  onFinish,
  onCancel,
  customForm,
  footer,
  initialValue,
}: IBaseForm) => {
  const { goBack } = useNavigation();
  const formRef = useRef(null) as any;

  let useFormInstance: UseFormReturnType;

  if (isEmpty(customForm)) {
    useFormInstance = useForm();
  } else {
    useFormInstance = customForm;
  }

  function onSubmit(data: any) {
    onFinish(data);
  }

  /**
   *
   * @param children - Children to generate
   * @returns
   * @description Re-Generate children and modify all children if it's FormField
   */
  function generateChildren(children: any): any {
    return Children.map(children, (child) => {
      if (child?.type?.code === 'FormField') {
        return cloneElement(child, {
          onChange: (data) => {
            useFormInstance.setValue(child.props.name, data);
            if (child?.props?.onChange) {
              child.props.onChange(data);
            }
          },
          value: useFormInstance.watch(child.props.name, child.props?.value),
        });
      } if (child?.props?.children) {
        return cloneElement(child, {
          children: generateChildren(child.props.children),
        });
      }
      return child;
    });
  }

  useEffect(() => {
    if (!isEmpty(initialValue)) {
      for (const [field, value] of Object.entries(initialValue)) {
        useFormInstance.setValue(field, value);
      }
    }
  }, []);

  return (
    <form
      ref={formRef}
      onSubmit={useFormInstance.handleSubmit(onSubmit)}
    >
      {generateChildren(children)}

      {
        footer || (
          <div className="flex justify-end space-x-2">
            <Button
              className="space-x-2"
              size="md"
              variant="primary"
              backgroundColor="red"
              onClick={() => (onCancel ? onCancel() : goBack())}
              type="button"
            >
              Batal
            </Button>
            <Button
              size="md"
              variant="primary"
              type="submit"
            >
              Simpan
            </Button>
          </div>
        )
      }

    </form>
  );
};
